var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-usermenu",style:({minHeight: _vm.minHeight})},[_c('Usermenu',{staticClass:"usermenu",attrs:{"id":_vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }